<div class="lightTheme">
  <div *ngIf="isLoader" class="svg-loader"></div>
  <div class="d-flex flex-row page-header">
    Data Cleansing
    <button (click)="addCleansingRule()" class="btn actionBtn add p-0">&nbsp;</button>
  </div>

  <div class="d-flex search_filter_area">
    <div class="d-inline-block" id="searchBar">
      <input class="form-control" type="text"
        (keyup)="globalService.applyFilter($event.target.value, rulesDataSource); setSearchText($event.target.value);"
        placeholder="Search" [(ngModel)]="searchText">
      <span class="searchIcon"><mat-icon aria-hidden="false" aria-label="search">search</mat-icon></span>
    </div>
    <div class="col-8 col-sm-8 col-md-8 col-lg-8 regularText">
      <mat-chip-listbox #chipList>
        <mat-chip-option *ngFor="let element of selectedFilters" [removable]="true" (removed)="remove(element)">
          {{globalService.replaceDisplayText(element.selectedFieldName) + " " + element.selectedCondition + " " +
          element.selectedValue}}
          <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
        </mat-chip-option>
      </mat-chip-listbox>
    </div>
    <div class="tbl_head_action float-right">
      <span class="filterIcon" placement="left-top" [ngbPopover]="addFilter" #popOver="ngbPopover"
        popoverTitle="Add Filter" autoClose="outside" popoverClass="popClassWidth">&nbsp;</span>
      <span class="exportIcon"
        (click)="exporterRules.exportTable('xlsx', {fileName:'Rules', sheet: 'Rules'})"
        (keydown)="exporterRules.exportTable('xlsx', {fileName:'Rules', sheet: 'Rules'})">&nbsp;</span>
    </div>
  </div>

  <div class="d-flex flex-column foundationTable">
    <mat-table matTableExporter [dataSource]="rulesDataSource" matSort matSortDirection="asc" matSortDisableClear #exporterRules="matTableExporter" hiddenColumns="[5]">

      <ng-container matColumnDef="dataSourceName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="matDatasource">Data Source</mat-header-cell>
        <mat-cell *matCellDef="let element"><span class="">{{element.dataSourceName}}</span></mat-cell>
      </ng-container>
      <ng-container matColumnDef="tagName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Tag Name</mat-header-cell>
        <mat-cell *matCellDef="let element" class="regularText">
          <span *ngIf="element.tagName!=null && element.tagName.length<=40">{{element.tagName}}</span>
          <span *ngIf="element.tagName!=null && element.tagName.length>40" ngbTooltip="{{element.tagName}}"
            placement="bottom">{{element.tagName.slice(0,40)}}</span>
          <span *ngIf="element.tagName!=null && element.tagName.length>40">...</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="cleansingRules">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Number of Rules</mat-header-cell>
        <mat-cell *matCellDef="let element"><span class="">{{element.cleansingRules.length}}</span></mat-cell>
      </ng-container>
      <ng-container matColumnDef="updatedBy">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Modified By</mat-header-cell>
        <mat-cell *matCellDef="let element"><span class="">{{element.updatedBy}}</span></mat-cell>
      </ng-container>
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
        <mat-cell class="tbl_action" *matCellDef="let element; let i=index">
          <button class="actionIcon  pointer" matTooltip="View" mat-icon-button (click)="viewDetails(element)">
            <mat-icon class="action-icon-view"></mat-icon>
          </button>
          <button class="actionIcon pointer" matTooltip="Edit" mat-icon-button (click)="editDetails(element)">
            <mat-icon class="action-icon-edit"></mat-icon>
          </button>
          <button class="actionIcon pointer" (click)="deleteModel(element)" matTooltip="Delete" mat-icon-button>
            <mat-icon class="action-icon-delete"></mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns;sticky: true" stickybits></mat-header-row>
      <mat-row *matRowDef="let rows; columns: displayedColumns;"></mat-row>
    </mat-table>
    <div class="emptyRepoMsg" *ngIf="(!isLoader) && (rulesDataSource.data.length === 0)"><span> There are no records to
        display.</span></div>
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10,50,100,500,1000]"
      [hidden]="!rulesDataSource.data.length"></mat-paginator>
  </div>

  <ng-template #addFilter><app-add-filter [filterList]="filterList" [selectedFilters]="selectedFilters"
      [application]="'rules'" (filterResponse)="filterResponse($event)"></app-add-filter></ng-template>
</div>